<template>
  <b-container>
    <b-row align-h="center" class="main-content smooth" :class="{'mt-3':this.cards.length !== 0}">
      <Spinner
      align-self="center"
      :offline="this.error"
      :loading="this.fetching"
      @retry-action="fetchCards()"
      />
      <div class="w-100" v-if="this.cards.length !== 0 && !this.error"></div>
      <b-card-group align-self="start" style="width:93%" v-if="(!this.fetching || this.cards.length !== 0) && !this.error" columns>
        <Card
        v-for="card in cards"
        :card="card"
        :Nmode="nightMode"
        :key="card.cid"
        :lock="fetching"
        @actions="actions"
        class="mb-3"
        />
      </b-card-group>
    </b-row>

    <b-modal
      v-model="modalShow1"
      ref="modal"
      :title="(!this.showOtherInput)?'输入操作金额':'输入操作金额和目标卡号'"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <div v-if="this.showOtherInput" class="input-group">
        <div class="input-group-prepend mb-2">
          <span class="input-group-text" id="to_cid">目标卡号</span>
        </div>
        <input type="text" class="form-control" v-model="to_cid" aria-describedby="to_cid" autocomplete="off">
      </div>
      <div class="input-group">
        <div class="input-group-prepend mb-2">
          <span class="input-group-text" id="amount">操作金额</span>
        </div>
        <input type="number" class="form-control" v-model="amount" aria-describedby="amount" autocomplete="off">
      </div>
    </b-modal>

    <b-modal
      v-model="modalShow2"
      ref="modal"
      title="贷款"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <b-row class="mx-3" v-if="!payLoan">
        <b-form-group label="可选贷款">
          <b-form-radio-group
            v-model="selected"
            :options="processedRatios"
            name="radios-stacked"
            stacked
          ></b-form-radio-group>
        </b-form-group>
        <div class="input-group mx-0">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text" id="lamount">贷款金额</span>
          </div>
          <input type="number" class="form-control" v-model="amount" aria-describedby="lamount" autocomplete="off">
        </div>
      </b-row>
      <b-row class="mx-3" v-if="payLoan">
        <h5>本卡贷款金额：{{this.nowCard.amount}}￥</h5>
        <h5>贷款利息：{{`${this.nowCard.amount}*${loanObj.days}*${loanObj.ratio}=${this.nowCard.amount*loanObj.days*loanObj.ratio}￥`}}</h5>
        <h5>总金额：{{`${loanObj.total}￥`}}</h5>
      </b-row>
    </b-modal>

  </b-container>
</template>

<style>
  .campaignView {
    padding-top: 54px;
  }
</style>

<script>
import Spinner from '../components/LoadingSpinner.vue'
import Card from '@/components/Card.vue'
import {auth} from '../components/auth'
import {urls} from '../components/urls'

export default {
    name:'cards',
    components:{
      Card,
      Spinner
    },
    mixins:[auth,urls],
    data: function (){
		return {
      cards:[],
      fetching:true,
      error:false,
      nightMode:false,
      modalShow1:false,
      showOtherInput:false,
      modalShow2:false,
      payLoan:false,
      amount:0,
      cid:"",
      nowCard:{},
      to_cid:"",
      type:"",
      ratios:[],
      selected:0
		}
    },
    methods: {
      showToast:function(obj){
        this.$bvToast.toast(`${obj.content}`, {
          title: `${obj.title}`,
          toaster: obj.toaster,
          variant: obj.variant,
          solid: true,
          appendToast: true
        })
      },
      fetchCards:function(){
        this.fetching=true;
        this.$axios.get(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card",{headers: { "Authorization" : this.header}})
        .then(res=>{
          this.cards=res.data
          this.error=false;
          this.fetching=false;
        })
        .catch(error => {
          this.error=true;
          this.fetching=false;
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
      },
      fetchRatios:function(){
        this.$axios.get(this.fetchUrl+"/api/ratio",{headers: { "Authorization" : this.header}})
          .then(res=>{
            this.ratios=res.data;
            return 0
          })
          .catch(error => {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
          });
      },
      actions:function(obj){
        this.type=obj.type;
        this.cid=obj.cid;
        this.nowCard=obj.card;
        this.amount=0;
        this.to_cid="";
        this.selected="";
        if(obj.type==="deposit"||obj.type==="withdraw"||obj.type==="transfer"){
          if(obj.type==="transfer")this.showOtherInput=true;
          else this.showOtherInput=false;
          this.modalShow1=true;
        }
        if(obj.type==="loan"||obj.type==="pay_loan"){
          if(obj.type==="loan")this.payLoan=false;
          else this.payLoan=true;
          this.modalShow2=true;
        }
        return 0
      },
      handleOk:function(bvModalEvt){
        let postfix="";
        if(this.type!=="pay_loan"){
          if(this.cid.trim()===""||this.type.trim()===""||this.amount===0||!this.amount){
            bvModalEvt.preventDefault()
            this.showToast({content:'操作失败,请检查你的输入金额',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'})
            return 1
          }
          if(this.type==="transfer"&&this.to_cid.trim()===""){
            bvModalEvt.preventDefault()
            this.showToast({content:'操作失败，请检查你的输入卡号',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'})
            return 1
          }
          if(this.type==="loan"&&this.nowCard.loan_max<this.amount){
            bvModalEvt.preventDefault()
            this.showToast({content:`输入金额大于该卡最大贷款金额(${this.nowCard.loan_max}￥)`,variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'})
            return 1
          }
        }else{
          if(this.nowCard.balance+this.nowCard.overdraft_max<this.loanObj.total){
            bvModalEvt.preventDefault()
            this.showToast({content:`所需金额(${this.loanObj.total})大于该卡目前最大可支付金额(${this.nowCard.balance+this.nowCard.overdraft_max}￥)`,variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'})
            return 1
          }
        }
        this.modalShow1=false;
        switch(this.type){
          case "deposit":
            this.transaction();
            break;
          case "withdraw":
            this.transaction();
            break;
          case "transfer":
            this.transaction();
            break;
          case "loan":
            this.loan();
            break;
          case "pay_loan":
            this.pay_loan();
            break;
          default:
            this.showToast({content:'未知操作',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'});
        }
        return 0
      },
      resetModal:function() {
        this.amount = 0;
        this.cid="";
        this.type="";
        this.to_cid="";
        this.selected="";
        this.nowCard={};
        return 0
      },
      handleCancel:function(){
        this.resetModal();
        this.showToast({content:'操作取消',variant:'warning',toaster:'b-toaster-bottom-center',title:'警告'})
        return 0
      },
      transaction:function(){
        let to_cidt=null;
        if(this.type==="transfer")to_cidt=this.to_cid;
        this.fetching=true;
        this.$axios.post(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card/"+this.cid+"/transaction",
        {
          type:this.type,
          amount:this.amount,
          to_cid:to_cidt
        }
        ,{headers: { "Authorization" : this.header}})
          .then(res=>{
            this.showToast({content:'操作成功',variant:'success',toaster:'b-toaster-bottom-center',title:'提示'});
            this.fetchCards();
            this.resetModal();
            this.fetching=false;
            return 0
          })
          .catch(error => {
            this.showToast({content:'操作失败',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'});
            this.resetModal();
            this.fetching=false;
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
          });
      },
      loan:function(){
        this.fetching=true;
        this.$axios.post(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card/"+this.cid+"/loan",
        {
          rid:this.selected,
          amount:this.amount,
        }
        ,{headers: { "Authorization" : this.header}})
          .then(res=>{
            this.showToast({content:'操作成功',variant:'success',toaster:'b-toaster-bottom-center',title:'提示'});
            this.fetchCards();
            this.resetModal();
            this.fetching=false;
            return 0
          })
          .catch(error => {
            this.showToast({content:'操作失败',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'});
            this.resetModal();
            this.fetching=false;
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
          });
      },
      pay_loan:function(){
        this.fetching=true;
        this.$axios.delete(this.fetchUrl+"/api/user/"+this.userInfo.uid+"/card/"+this.cid+"/loan/"+this.nowCard.lid,{headers: { "Authorization" : this.header}})
          .then(res=>{
            this.showToast({content:'操作成功',variant:'success',toaster:'b-toaster-bottom-center',title:'提示'});
            this.fetchCards();
            this.resetModal();
            this.fetching=false;
            return 0
          })
          .catch(error => {
            this.showToast({content:'操作失败',variant:'danger',toaster:'b-toaster-bottom-center',title:'错误'});
            this.resetModal();
            this.fetching=false;
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
          });
      }
    },
    computed:{
      atTabName(){
        return this.$route.name
      },
      processedRatios(){
        const temp=this.ratios.map(ratio=>{
          return {
            text:`利率${ratio.ratio*100}%`,
            value:ratio.rid
          }
        })
        return temp
      },
      loanObj(){
        if(!this.nowCard.lid)return {days:0,ratio:0,total:0};
        const current=Date.now(),start=Date.parse(this.nowCard.start_date);
        let days=(current-start)/(24*3600*1000);
        let thisRatio;
        this.ratios.map(ratio=>{
          if(ratio.rid===this.nowCard.rid)thisRatio=ratio.ratio;
          return ratio
        })
        days=parseInt(days)+1;
        return {days:days,ratio:thisRatio,total:this.nowCard.amount*days*thisRatio+this.nowCard.amount}
      }
    },
    mounted(){
      this.fetchCards();
      this.fetchRatios();
    }
}
</script>

